// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/common/type/v1/block_schema.proto (package fingertip.common.type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Media } from "./media_pb.js";
import { Poll } from "./poll_pb.js";
import { PollOption } from "./poll_option_pb.js";
import { FormTemplate } from "./form_template_pb.js";
import { StoreProduct } from "./store_product_pb.js";
import { Asset } from "./asset_pb.js";
import { BlogPost } from "./blog_post_pb.js";
import { Video } from "./video_pb.js";

/**
 * @generated from message fingertip.common.type.v1.SM
 */
export const SM = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.SM",
  () => [
    { no: 1, name: "x", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "y", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "w", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "h", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.SocialIconContent
 */
export const SocialIconContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.SocialIconContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "social_urls", kind: "message", T: SocialUrl, repeated: true },
    { no: 5, name: "show_color", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.SocialUrl
 */
export const SocialUrl = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.SocialUrl",
  () => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.WebsiteContent
 */
export const WebsiteContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.WebsiteContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "website_urls", kind: "message", T: WebsiteUrl, repeated: true },
    { no: 4, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "button_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "media", kind: "message", T: Media },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.WebsiteUrl
 */
export const WebsiteUrl = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.WebsiteUrl",
  () => [
    { no: 1, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "open_in_new_tab", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.IframeContent
 */
export const IframeContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.IframeContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "html", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_modal", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.WebsiteEmbedContent
 */
export const WebsiteEmbedContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.WebsiteEmbedContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_modal", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.OpeningHoursContent
 */
export const OpeningHoursContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.OpeningHoursContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "location_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "google_place_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "use_manual_override", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "monday", kind: "message", T: OpeningHoursDay },
    { no: 7, name: "tuesday", kind: "message", T: OpeningHoursDay },
    { no: 8, name: "wednesday", kind: "message", T: OpeningHoursDay },
    { no: 9, name: "thursday", kind: "message", T: OpeningHoursDay },
    { no: 10, name: "friday", kind: "message", T: OpeningHoursDay },
    { no: 11, name: "saturday", kind: "message", T: OpeningHoursDay },
    { no: 12, name: "sunday", kind: "message", T: OpeningHoursDay },
    { no: 13, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "always_open", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "hide_open_today", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.OpeningHoursMeta
 */
export const OpeningHoursMeta = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.OpeningHoursMeta",
  () => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "google_place_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "monday", kind: "message", T: OpeningHoursDay },
    { no: 4, name: "tuesday", kind: "message", T: OpeningHoursDay },
    { no: 5, name: "wednesday", kind: "message", T: OpeningHoursDay },
    { no: 6, name: "thursday", kind: "message", T: OpeningHoursDay },
    { no: 7, name: "friday", kind: "message", T: OpeningHoursDay },
    { no: 8, name: "saturday", kind: "message", T: OpeningHoursDay },
    { no: 9, name: "sunday", kind: "message", T: OpeningHoursDay },
    { no: 10, name: "location_always_open", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.OpeningHoursDay
 */
export const OpeningHoursDay = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.OpeningHoursDay",
  () => [
    { no: 1, name: "times", kind: "message", T: OpeningHoursTime, repeated: true },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.OpeningHoursTime
 */
export const OpeningHoursTime = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.OpeningHoursTime",
  () => [
    { no: 1, name: "start_time", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "end_time", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.RatingsContent
 */
export const RatingsContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.RatingsContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "location_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "google_place_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "show_reviews", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "custom_rating", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "custom_ratings_total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "custom_ratings_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.RatingsMeta
 */
export const RatingsMeta = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.RatingsMeta",
  () => [
    { no: 1, name: "rating", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "google_place_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ratings_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "reviews", kind: "message", T: RatingsMeta_Review, repeated: true },
    { no: 6, name: "ratings_total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.RatingsMeta.Review
 */
export const RatingsMeta_Review = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.RatingsMeta.Review",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rating", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "profile_photo_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "RatingsMeta_Review"},
);

/**
 * @generated from message fingertip.common.type.v1.FileContent
 */
export const FileContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.FileContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "file_asset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "file_asset_src", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "file_asset_bucket", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "button_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "media", kind: "message", T: Media },
    { no: 10, name: "collect_email", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.SpotifyContent
 */
export const SpotifyContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.SpotifyContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 4, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.SpotifyMeta
 */
export const SpotifyMeta = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.SpotifyMeta",
  () => [
    { no: 1, name: "data", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.TextContent
 */
export const TextContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.TextContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "hide_background", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.GalleryContentAsset
 */
export const GalleryContentAsset = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.GalleryContentAsset",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "media", kind: "message", T: Media },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.GalleryContent
 */
export const GalleryContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.GalleryContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "assets", kind: "message", T: GalleryContentAsset, repeated: true },
    { no: 4, name: "hide_background", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.MapContent
 */
export const MapContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.MapContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "location_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "google_place_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "zoom", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.MapMeta
 */
export const MapMeta = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.MapMeta",
  () => [
    { no: 1, name: "lat", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "lng", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "google_place_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "location_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.SubscribeContent
 */
export const SubscribeContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.SubscribeContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "button_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "collect_phone_number", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "collect_full_name", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "hide_conditions", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.CalendarContent
 */
export const CalendarContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.CalendarContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "event_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "start_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "start_time", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "end_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "end_time", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "button_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.ContactItem
 */
export const ContactItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.ContactItem",
  () => [
    { no: 1, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.ContactContent
 */
export const ContactContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.ContactContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "full_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "organization", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "job_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "items", kind: "message", T: ContactItem, repeated: true },
    { no: 9, name: "media", kind: "message", T: Media },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.FaqContentFaq
 */
export const FaqContentFaq = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.FaqContentFaq",
  () => [
    { no: 1, name: "question", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "answer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.FaqContent
 */
export const FaqContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.FaqContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "faqs", kind: "message", T: FaqContentFaq, repeated: true },
    { no: 4, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "button_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.PollContent
 */
export const PollContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.PollContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "poll_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.PollMeta
 */
export const PollMeta = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.PollMeta",
  () => [
    { no: 1, name: "poll", kind: "message", T: Poll },
    { no: 2, name: "poll_options", kind: "message", T: PollOption, repeated: true },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.FormContent
 */
export const FormContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.FormContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "form_template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.FormMeta
 */
export const FormMeta = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.FormMeta",
  () => [
    { no: 1, name: "form_template", kind: "message", T: FormTemplate },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.BannerContent
 */
export const BannerContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.BannerContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "media", kind: "message", T: Media },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.ProductContentProduct
 */
export const ProductContentProduct = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.ProductContentProduct",
  () => [
    { no: 1, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "product_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "product_price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "media", kind: "message", T: Media },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.ProductContent
 */
export const ProductContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.ProductContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "products", kind: "message", T: ProductContentProduct, repeated: true },
    { no: 4, name: "product_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "button_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.ProductMeta
 */
export const ProductMeta = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.ProductMeta",
  () => [
    { no: 1, name: "products", kind: "message", T: StoreProductItem, repeated: true },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.BookingContent
 */
export const BookingContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.BookingContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "media", kind: "message", T: Media },
    { no: 7, name: "button_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.BookingMeta
 */
export const BookingMeta = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.BookingMeta",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "has_event_type", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "booking_onboarding_completed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.SocialIconGroupContent
 */
export const SocialIconGroupContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.SocialIconGroupContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "social_icon_group_items", kind: "message", T: SocialIconGroupItem, repeated: true },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.SocialIconGroupItem
 */
export const SocialIconGroupItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.SocialIconGroupItem",
  () => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.TestimonialsContent
 */
export const TestimonialsContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.TestimonialsContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "testimonials", kind: "message", T: TestimonialItem, repeated: true },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.TestimonialItem
 */
export const TestimonialItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.TestimonialItem",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "subtitle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "media", kind: "message", T: Media },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.PageBreakContent
 */
export const PageBreakContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.PageBreakContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "show_divider", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "style_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.ServicesContent
 */
export const ServicesContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.ServicesContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "services", kind: "message", T: ServiceItem, repeated: true },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.ServiceItem
 */
export const ServiceItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.ServiceItem",
  () => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.ServiceAreasContent
 */
export const ServiceAreasContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.ServiceAreasContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "service_areas", kind: "message", T: ServiceItem, repeated: true },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.ServiceAreaItem
 */
export const ServiceAreaItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.ServiceAreaItem",
  () => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.StoreProductItem
 */
export const StoreProductItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.StoreProductItem",
  () => [
    { no: 1, name: "product", kind: "message", T: StoreProduct },
    { no: 2, name: "assets", kind: "message", T: Asset, repeated: true },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.StoreTipContent
 */
export const StoreTipContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.StoreTipContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "button_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "custom_amount_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "default_tip_amount", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "tip_amounts", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.StoreTipMeta
 */
export const StoreTipMeta = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.StoreTipMeta",
  () => [
    { no: 1, name: "has_active_connection", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.BlogPostContent
 */
export const BlogPostContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.BlogPostContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "button_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "blog_post_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.BlogPostItem
 */
export const BlogPostItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.BlogPostItem",
  () => [
    { no: 1, name: "post", kind: "message", T: BlogPost },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.BlogPostMeta
 */
export const BlogPostMeta = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.BlogPostMeta",
  () => [
    { no: 1, name: "posts", kind: "message", T: BlogPostItem, repeated: true },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.SocialFeedContent
 */
export const SocialFeedContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.SocialFeedContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.SocialPost
 */
export const SocialPost = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.SocialPost",
  () => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "img_src", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "img_width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "img_height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.SocialFeedMeta
 */
export const SocialFeedMeta = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.SocialFeedMeta",
  () => [
    { no: 1, name: "posts", kind: "message", T: SocialPost, repeated: true },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "followers_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.TeamContent
 */
export const TeamContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.TeamContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "teams", kind: "message", T: TeamItem, repeated: true },
    { no: 4, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.TeamItem
 */
export const TeamItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.TeamItem",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "bio", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "job_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "media", kind: "message", T: Media },
    { no: 5, name: "socials", kind: "message", T: TeamSocialItem, repeated: true },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.TeamSocialItem
 */
export const TeamSocialItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.TeamSocialItem",
  () => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.AppleMusicEmbedContent
 */
export const AppleMusicEmbedContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.AppleMusicEmbedContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "html", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.SoundCloudEmbedContent
 */
export const SoundCloudEmbedContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.SoundCloudEmbedContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "html", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.LoomEmbedContent
 */
export const LoomEmbedContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.LoomEmbedContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "html", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.PinterestEmbedContent
 */
export const PinterestEmbedContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.PinterestEmbedContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "html", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.CalendlyEmbedContent
 */
export const CalendlyEmbedContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.CalendlyEmbedContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "html", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.FigmaEmbedContent
 */
export const FigmaEmbedContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.FigmaEmbedContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "html", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.TikTokEmbedContent
 */
export const TikTokEmbedContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.TikTokEmbedContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "html", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.InstagramEmbedContent
 */
export const InstagramEmbedContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.InstagramEmbedContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "html", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.TwitchEmbedContent
 */
export const TwitchEmbedContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.TwitchEmbedContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "html", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.XEmbedContent
 */
export const XEmbedContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.XEmbedContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "html", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.IconGroupIcon
 */
export const IconGroupIcon = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.IconGroupIcon",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "media", kind: "message", T: Media },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.IconGroupContent
 */
export const IconGroupContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.IconGroupContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "icons", kind: "message", T: IconGroupIcon, repeated: true },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.QuotationContent
 */
export const QuotationContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.QuotationContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "media", kind: "message", T: Media },
    { no: 5, name: "full_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.PortfolioContentAsset
 */
export const PortfolioContentAsset = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.PortfolioContentAsset",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "media", kind: "message", T: Media },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.PortfolioContent
 */
export const PortfolioContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.PortfolioContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "assets", kind: "message", T: PortfolioContentAsset, repeated: true },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.SkillsContent
 */
export const SkillsContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.SkillsContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "skills", kind: "message", T: SkillItem, repeated: true },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.SkillItem
 */
export const SkillItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.SkillItem",
  () => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.LanguagesContent
 */
export const LanguagesContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.LanguagesContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "languages", kind: "message", T: LanguageItem, repeated: true },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.LanguageItem
 */
export const LanguageItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.LanguageItem",
  () => [
    { no: 1, name: "language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "proficiency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.WorkHistoryContent
 */
export const WorkHistoryContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.WorkHistoryContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "positions", kind: "message", T: PositionItem, repeated: true },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.PositionItem
 */
export const PositionItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.PositionItem",
  () => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "contract_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "company_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "company_location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "media", kind: "message", T: Media },
    { no: 7, name: "linkedin_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "linkedin_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "start_month", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "start_year", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "end_month", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "end_year", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.EducationContent
 */
export const EducationContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.EducationContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "schools", kind: "message", T: SchoolItem, repeated: true },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.SchoolItem
 */
export const SchoolItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.SchoolItem",
  () => [
    { no: 1, name: "school_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "degree_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "field_of_study", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "media", kind: "message", T: Media },
    { no: 5, name: "linkedin_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "start_month", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "start_year", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "end_month", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "end_year", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.ImageComparisonContent
 */
export const ImageComparisonContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.ImageComparisonContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "assets", kind: "message", T: ImageComparisonAsset, repeated: true },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.ImageComparisonAsset
 */
export const ImageComparisonAsset = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.ImageComparisonAsset",
  () => [
    { no: 1, name: "media", kind: "message", T: Media },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.WeatherContent
 */
export const WeatherContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.WeatherContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "location_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "google_place_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "units", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.WeatherMeta
 */
export const WeatherMeta = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.WeatherMeta",
  () => [
    { no: 1, name: "coord_lat", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "coord_lng", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "timezone", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "cod", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "weather_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "weather_main", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "weather_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "weather_icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "base", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "main_temp", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 13, name: "main_feels_like", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 14, name: "main_temp_min", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 15, name: "main_temp_max", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 16, name: "main_pressure", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "main_humidity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 18, name: "main_sea_level", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 19, name: "main_grnd_level", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 20, name: "visibility", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 21, name: "wind_speed", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 22, name: "wind_deg", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 23, name: "wind_gust", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 24, name: "rain_1h", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 25, name: "clouds_all", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 26, name: "dt", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 27, name: "sys_type", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 28, name: "sys_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 29, name: "sys_country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "sys_sunrise", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 31, name: "sys_sunset", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.QrContent
 */
export const QrContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.QrContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "data", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.ProjectContent
 */
export const ProjectContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.ProjectContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "assets", kind: "message", T: ProjectAsset, repeated: true },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.ProjectAsset
 */
export const ProjectAsset = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.ProjectAsset",
  () => [
    { no: 1, name: "media", kind: "message", T: Media },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "open_in_new_tab", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "button_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.LinkListItem
 */
export const LinkListItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.LinkListItem",
  () => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "media", kind: "message", T: Media },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.LinkListContent
 */
export const LinkListContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.LinkListContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "links", kind: "message", T: LinkListItem, repeated: true },
    { no: 4, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.VideoContent
 */
export const VideoContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.VideoContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "video", kind: "message", T: Video },
    { no: 4, name: "is_modal", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.AffiliateContent
 */
export const AffiliateContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.AffiliateContent",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "sm", kind: "message", T: SM },
    { no: 3, name: "website_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "button_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.BlockContent
 */
export const BlockContent = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.BlockContent",
  () => [
    { no: 1, name: "social_icon_content", kind: "message", T: SocialIconContent, oneof: "content" },
    { no: 2, name: "website_content", kind: "message", T: WebsiteContent, oneof: "content" },
    { no: 5, name: "iframe_content", kind: "message", T: IframeContent, oneof: "content" },
    { no: 6, name: "opening_hours_content", kind: "message", T: OpeningHoursContent, oneof: "content" },
    { no: 7, name: "ratings_content", kind: "message", T: RatingsContent, oneof: "content" },
    { no: 8, name: "file_content", kind: "message", T: FileContent, oneof: "content" },
    { no: 10, name: "spotify_content", kind: "message", T: SpotifyContent, oneof: "content" },
    { no: 11, name: "text_content", kind: "message", T: TextContent, oneof: "content" },
    { no: 12, name: "gallery_content", kind: "message", T: GalleryContent, oneof: "content" },
    { no: 14, name: "map_content", kind: "message", T: MapContent, oneof: "content" },
    { no: 15, name: "subscribe_content", kind: "message", T: SubscribeContent, oneof: "content" },
    { no: 16, name: "calendar_content", kind: "message", T: CalendarContent, oneof: "content" },
    { no: 17, name: "contact_content", kind: "message", T: ContactContent, oneof: "content" },
    { no: 18, name: "faq_content", kind: "message", T: FaqContent, oneof: "content" },
    { no: 19, name: "poll_content", kind: "message", T: PollContent, oneof: "content" },
    { no: 20, name: "form_content", kind: "message", T: FormContent, oneof: "content" },
    { no: 21, name: "banner_content", kind: "message", T: BannerContent, oneof: "content" },
    { no: 22, name: "product_content", kind: "message", T: ProductContent, oneof: "content" },
    { no: 23, name: "booking_content", kind: "message", T: BookingContent, oneof: "content" },
    { no: 24, name: "social_icon_group_content", kind: "message", T: SocialIconGroupContent, oneof: "content" },
    { no: 25, name: "testimonials_content", kind: "message", T: TestimonialsContent, oneof: "content" },
    { no: 26, name: "page_break_content", kind: "message", T: PageBreakContent, oneof: "content" },
    { no: 27, name: "services_content", kind: "message", T: ServicesContent, oneof: "content" },
    { no: 28, name: "service_areas_content", kind: "message", T: ServiceAreasContent, oneof: "content" },
    { no: 30, name: "store_tip_content", kind: "message", T: StoreTipContent, oneof: "content" },
    { no: 31, name: "blog_post_content", kind: "message", T: BlogPostContent, oneof: "content" },
    { no: 32, name: "social_feed_content", kind: "message", T: SocialFeedContent, oneof: "content" },
    { no: 33, name: "team_content", kind: "message", T: TeamContent, oneof: "content" },
    { no: 34, name: "apple_music_embed_content", kind: "message", T: AppleMusicEmbedContent, oneof: "content" },
    { no: 35, name: "soundcloud_embed_content", kind: "message", T: SoundCloudEmbedContent, oneof: "content" },
    { no: 36, name: "loom_embed_content", kind: "message", T: LoomEmbedContent, oneof: "content" },
    { no: 37, name: "pinterest_embed_content", kind: "message", T: PinterestEmbedContent, oneof: "content" },
    { no: 38, name: "calendly_embed_content", kind: "message", T: CalendlyEmbedContent, oneof: "content" },
    { no: 39, name: "figma_embed_content", kind: "message", T: FigmaEmbedContent, oneof: "content" },
    { no: 40, name: "tiktok_embed_content", kind: "message", T: TikTokEmbedContent, oneof: "content" },
    { no: 41, name: "instagram_embed_content", kind: "message", T: InstagramEmbedContent, oneof: "content" },
    { no: 42, name: "twitch_embed_content", kind: "message", T: TwitchEmbedContent, oneof: "content" },
    { no: 44, name: "x_embed_content", kind: "message", T: XEmbedContent, oneof: "content" },
    { no: 45, name: "icon_group_content", kind: "message", T: IconGroupContent, oneof: "content" },
    { no: 46, name: "quotation_content", kind: "message", T: QuotationContent, oneof: "content" },
    { no: 47, name: "portfolio_content", kind: "message", T: PortfolioContent, oneof: "content" },
    { no: 48, name: "skills_content", kind: "message", T: SkillsContent, oneof: "content" },
    { no: 49, name: "languages_content", kind: "message", T: LanguagesContent, oneof: "content" },
    { no: 50, name: "work_history_content", kind: "message", T: WorkHistoryContent, oneof: "content" },
    { no: 51, name: "education_content", kind: "message", T: EducationContent, oneof: "content" },
    { no: 52, name: "image_comparison_content", kind: "message", T: ImageComparisonContent, oneof: "content" },
    { no: 53, name: "weather_content", kind: "message", T: WeatherContent, oneof: "content" },
    { no: 54, name: "qr_content", kind: "message", T: QrContent, oneof: "content" },
    { no: 55, name: "project_content", kind: "message", T: ProjectContent, oneof: "content" },
    { no: 56, name: "link_list_content", kind: "message", T: LinkListContent, oneof: "content" },
    { no: 57, name: "video_content", kind: "message", T: VideoContent, oneof: "content" },
    { no: 58, name: "website_embed_content", kind: "message", T: WebsiteEmbedContent, oneof: "content" },
    { no: 59, name: "affiliate_content", kind: "message", T: AffiliateContent, oneof: "content" },
  ],
);

/**
 * @generated from message fingertip.common.type.v1.BlockMeta
 */
export const BlockMeta = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.BlockMeta",
  () => [
    { no: 1, name: "opening_hours_meta", kind: "message", T: OpeningHoursMeta, oneof: "meta_content" },
    { no: 2, name: "ratings_meta", kind: "message", T: RatingsMeta, oneof: "meta_content" },
    { no: 3, name: "map_meta", kind: "message", T: MapMeta, oneof: "meta_content" },
    { no: 4, name: "poll_meta", kind: "message", T: PollMeta, oneof: "meta_content" },
    { no: 5, name: "form_meta", kind: "message", T: FormMeta, oneof: "meta_content" },
    { no: 6, name: "booking_meta", kind: "message", T: BookingMeta, oneof: "meta_content" },
    { no: 7, name: "spotify_meta", kind: "message", T: SpotifyMeta, oneof: "meta_content" },
    { no: 9, name: "blog_post_meta", kind: "message", T: BlogPostMeta, oneof: "meta_content" },
    { no: 10, name: "social_feed_meta", kind: "message", T: SocialFeedMeta, oneof: "meta_content" },
    { no: 11, name: "weather_meta", kind: "message", T: WeatherMeta, oneof: "meta_content" },
    { no: 12, name: "store_tip_meta", kind: "message", T: StoreTipMeta, oneof: "meta_content" },
    { no: 13, name: "product_meta", kind: "message", T: ProductMeta, oneof: "meta_content" },
  ],
);

